// @flow

import type { Alternative } from '../../../types'

export function alternativeIdToAlternativeText (id: number, alternatives: Object): string {
  const alternative = getAlternativeFromId(id, getAlternativesFromPoll(alternatives))
  return getTextFromAlternative(alternative)
}

export function getAlternativeFromId (id: number, alternatives: Array<Alternative>): ?Alternative {
  return alternatives.find(alternative => alternative.id === id)
}

function getTextFromAlternative (alternative: ?Alternative) {
  if (!alternative) {
    return 'ukjent'
  }
  return alternative.text
}

export function getAlternativesFromPoll (poll: Object) {
  return poll.list.reduce((acc, alternativeId) => {
    acc.push(poll[alternativeId])
    return acc
  }, [])
}



// WEBPACK FOOTER //
// ./src/shared/widgets/LivePoll/helpers/alternativeUtils.js